import { AbstractPmsApiService } from "./abstract.service";
import { PropertyClass } from "../models";

/**
 * @class PropertyClassPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PropertyClass>}
 */
export class PropertyClassPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/type/:typeId/class(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param {...*} params
     * @returns {PropertyClass}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PropertyClass(attributes);
    }

    /**
     * @param {Object} params
     * @param {PropertyType} type
     * @returns {Promise.<PaginationCollection<PropertyClass>>}
     */
    get (params = {}, type = null) {

        const url = this.url({typeId: type ? type.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyClass} propertyClass
     * @param {PropertyType} type
     * @returns {Promise.<PropertyClass>}
     */
    create(propertyClass, type) {

        const url = this.url({typeId: type.id});

        return this.http
                   .post(url, propertyClass.toObjectExcept('type'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyClass} propertyClass
     * @returns {Promise.<PropertyClass>}
     */
    update(propertyClass) {

        const url = this.url({
                                 typeId: propertyClass.type.id,
                                 id: propertyClass.id
                             });

        return this.http
                   .put(url, propertyClass.toObjectExcept('type'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyClass} propertyClass
     * @returns {Promise.<boolean>}
     */
    delete(propertyClass) {

        const url = this.url({
                                 typeId: propertyClass.type.id,
                                 id: propertyClass.id
                             });

        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} classId
     * @param {Integer} typeId
     * @param {Object} params
     */
    show(typeId, classId, params = {}) {

        const url = this.url({
            typeId: typeId,
            id: classId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/property-class.service.js